<permission-checker [roles]="roles" (contentInit)="initContent()">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1 i18n="Stats Dashboard|Exam Card Stats Dashboard title@@stats-dashboard-exam-card-title">Participant Answer
          Sheet</h1>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page">
      <mat-spinner *ngIf="inProgress" color="primary" diameter="40" class="center-middle"></mat-spinner>

      <mat-card *ngIf="!inProgress && user && stats">
        <mat-card-header class="exam-card-header">
          <mat-card-title class="card-title">{{user.firstName}} {{user.lastName}}</mat-card-title>

          <mat-card-subtitle class="card-subtitle">
            <span class="text-disabled-color sub-header-section-header"
                  i18n="School details|School grade@@school-details-grade-sub-title">
              School grade:
            </span>
            <span class="mat-body-2">{{user.schoolGrade}}
              <ng-container *ngIf="stats.exam?.taskType">
                ({{localizeTaskType(stats.exam?.taskType)}})
              </ng-container></span>
          </mat-card-subtitle>

          <mat-card-subtitle *ngIf="contest" class="card-subtitle">
            <span class="text-disabled-color sub-header-section-header"
                  i18n="Stats Dashboard|Exam Card Stats contest name title@@stats-dashboard-exam-card-contest-name-title">
              Contest:
            </span>
            <span class="mat-body-2">{{contest.name}}</span>
          </mat-card-subtitle>

          <mat-card-subtitle
            *ngIf="stats.exam || (!stats.participated && contest && contest.endsAt && contest.endsAt < today)"
            class="card-subtitle"
            [class.color-green]="stats.exam?.grade == examGrades.excellent"
            [class.color-orange]="stats.exam?.grade == examGrades.good">
            <span class="text-disabled-color sub-header-section-header"
                  i18n="Stats Dashboard|Exam Card Stats exam grade title@@stats-dashboard-exam-card-exam-grade-title">Result:</span>
            <span class="mat-body-2">{{localizeExamGrade(stats.exam)}}</span>

            <span class="fill-space"></span>

            <span class="certificate-holder">
              <app-link icon="verified"
                        label="get certificate"
                        [disabled]="certificateNotConfigured"
                        i18n-label="Stats Dashboard|Exam Card get certificate title@@stats-dashboard-exam-card-get-certificate-title"
                        (click)="requestCertificate(user.id)"></app-link>
              <mat-spinner *ngIf="certificateGetInProgress" diameter="20" color="primary" class="progress"></mat-spinner>
              <a *ngIf="!certificateGetInProgress && certificateUrl" [href]="certificateUrl" target="_blank"
                 class="progress">
                <mat-icon color="primary"
                          matTooltip="Certificate"
                          i18n-matTooltip="General|Contest certificate term@@general-contest-certificate-term">fact_check</mat-icon>
              </a>
            </span>

            <span *ngIf="contest && contest.taskInfoUrl" class="tasks-book-holder">
              <app-link icon="auto_stories"
                        label="tasks book"
                        i18n-label="Stats Dashboard|Exam Card tasks book title@@stats-dashboard-exam-card-tasks-book-title"
                        [href]="contest.taskInfoUrl"
                        [external]="true"></app-link>
            </span>
          </mat-card-subtitle>

          <mat-card-subtitle *ngIf="stats.exam" class="card-subtitle">
            <span class="text-disabled-color sub-header-section-header"
                  i18n="Stats Dashboard|Exam Card Stats total points title@@stats-dashboard-exam-card-total-points-title">Total points:</span>
            <span class="mat-body-2">{{stats.exam.points?.toFixed(2)}}</span>
          </mat-card-subtitle>
        </mat-card-header>

        <mat-card-content class="card-content">
          <div *ngIf="stats.exam && stats.events && taskStats;else noStatsInfo" fxLayout="row wrap">
            <answer-sheet *ngFor="let sectionIndex of taskStats.section_indexes"
                          fxFlex.lt-sm="98%" fxFlex.sm="48%" fxFlex.gt-sm="33%"
                          class="answer-sheet"
                          [sectionIndex]="sectionIndex"
                          [taskStats]="taskStats"
                          [taskAnswerEvents]="answers.get(sectionIndex) || []"></answer-sheet>
            <div class="fill-space"></div>
          </div>
          <ng-template #noStatsInfo>
            <app-no-content *ngIf="!stats || stats.participated"
                            [compact]="true"
                            class="no-data-info"
                            title="No statistical data available at the moment"
                            i18n-title="Stats|User exam card stats missing title@@stats-user-exam-card-stats-missing-title"
                            details="Stats will be populated after student participates in the contest and all results are counted"
                            i18n-details="Stats|User exam card stats missing details@@stats-user-exam-card-stats-missing-details"></app-no-content>
            <app-no-content *ngIf="stats && !stats.participated"
                            [compact]="true"
                            class="no-data-info"
                            title="The student hasn't taken part in this contest"
                            i18n-title="Stats|User exam card not participated title@@stats-user-exam-card-not-participated-title"
                            details="There is no statistical data recorded so that no contest results can be shown. However, you can still request a certificate of participation."
                            i18n-details="Stats|User exam card not participated details@@stats-user-exam-card-not-participated-details"></app-no-content>
          </ng-template>
        </mat-card-content>

        <mat-card-footer class="card-footer">
          <div *ngIf="stats.exam" class="center-align full-width">
            <span class="text-disabled-color sub-header-section-header"
                  i18n="Stats Dashboard|Exam Card Stats points calculation title@@stats-dashboard-exam-card-points-calculation-title">Points calculation:</span>
            <span class="mat-body-2">{{stats.exam.points}}</span>
            <span>&nbsp;=&nbsp;</span>
            <span *ngIf="stats.exam.initPoints"
                  class="mat-body-2 text-disabled-color init-points">{{stats.exam.initPoints}}</span>
            <span class="mat-body-2">{{getTotalPointsCalculation(stats.exam)}}</span>
            <span *ngIf="stats.exam.bonusPoints"
                  class="mat-body-2 color-primary bonus-points">{{getBonusPointsCalculation(stats.exam.bonusPoints)}}</span>
          </div>

          <div *ngIf="stats && stats.exam && stats.exam.bonusDescription"
               class="center-align color-primary mat-small">
            {{stats.exam.bonusDescription}}
          </div>

          <div *ngIf="stats.exam" class="card-legend">
            <span class="fill-space"></span>
            <span>
              <span class="answer-sheet-correct-answer mat-body-2 legend-answer-item">{{getAnswerLabel(1)}}</span> -
              <ng-container
                i18n="Stats Dashboard|Exam Card legend correct title@@stats-dashboard-exam-card-legend-correct-title">participant answer (correct)</ng-container>
            </span>
            <span class="legend-item">
              <span class="answer-sheet-incorrect-answer mat-body-2 legend-answer-item">{{getAnswerLabel(1)}}</span> -
              <ng-container
                i18n="Stats Dashboard|Exam Card legend incorrect title@@stats-dashboard-exam-card-legend-incorrect-title">participant answer (incorrect)</ng-container>
            </span>
            <span class="legend-item">
              <span class="answer-sheet-missing-answer mat-body-2 legend-answer-item">{{getAnswerLabel(1)}}</span> -
              <ng-container
                i18n="Stats Dashboard|Exam Card legend missing correct title@@stats-dashboard-exam-card-legend-missing-correct-title">missing correct answer</ng-container>
            </span>
            <span class="fill-space"></span>
          </div>
        </mat-card-footer>
      </mat-card>
    </div>
  </div>
</permission-checker>
